import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=13b6e0c7&scoped=true&"
import script from "./closed.vue?vue&type=script&lang=js&"
export * from "./closed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6e0c7",
  null
  
)

export default component.exports